// extracted by mini-css-extract-plugin
module.exports = {"container":"NavBar_container__TBgTv","component":"NavBar_component__y0tdz","link":"NavBar_link__2VB5A","newMemoButton":"NavBar_newMemoButton__RideG"};